import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";
import { useEffect, useRef } from "react";
import { useAppSelector } from "store/hooks";

type TitleFieldProps = {
  name: string;
  value: string;
  onChange: (value: any) => void;
};

const TitleField = (props: TitleFieldProps) => {
  const inputRef = useRef<HTMLElement | null>(null);

  const selectedRoute = useAppSelector(
    (state) => state.developer.edit.editor.selectedRoute
  );

  useEffect(() => {
    if (selectedRoute) {
      inputRef.current && inputRef.current.focus();
    }
  }, [selectedRoute]);

  return (
    <EditorVisualTextField
      label="Title"
      size="small"
      fullWidth
      inputRef={inputRef}
      name={props.name}
      value={props.value}
      onChange={props.onChange}
    />
  );
};

export default TitleField;
